import { type LatLng } from '~/_shared/types/latLng';
import { GoogleMapsOverlayViewContainer } from '~/map/map/mapOverlays/_shared/googleMapsOverlayViewContainer';
import { ActiveMarkerCircleIndicatorComponent } from '~/map/map/mapOverlays/activeMarkerIndicator/activeMarkerCircleIndicator.component';
import { ActiveMarkerPulsatingIndicatorComponent } from '~/map/map/mapOverlays/activeMarkerIndicator/activeMarkerPulsatingIndicator.component';

const HIGHLIGHT_SIZE = 100;
const HIGHLIGHT_SPEED = 50;
const MARKER_COLOR = '#00538f';

type ActiveProximityCenterHighlightProps = {
  center: LatLng;
  map?: google.maps.Map;
};

export const ActiveProximityCenterHighlightContainer = ({
  center,
  map,
}: ActiveProximityCenterHighlightProps) => {
  return (
    <GoogleMapsOverlayViewContainer
      position={center}
      map={map}
      noMouseEvents
    >
      <ActiveMarkerCircleIndicatorComponent
        diameter={HIGHLIGHT_SIZE}
        topOffset={HIGHLIGHT_SIZE / 2 + 1}
        leftOffset={HIGHLIGHT_SIZE / 2 + 1}
      >
        <ActiveMarkerPulsatingIndicatorComponent
          color={MARKER_COLOR}
          speed={HIGHLIGHT_SPEED}
        />
      </ActiveMarkerCircleIndicatorComponent>
    </GoogleMapsOverlayViewContainer>
  );
};
